import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@features/auth';

import LoadingSpinner from '@/shared/ui/LoadingSpinner/LoadingSpinner';
import { PROTECTED_ROUTES, USER_ROLES } from '@/shared/constants';

interface PublicRouteProps {
    children: ReactNode;
    redirectTo?: string;
}

const PublicRoute = ({ children, redirectTo = PROTECTED_ROUTES.DASHBOARD }: PublicRouteProps): ReactNode => {
    const { user, userProfile, loading } = useAuth();

    if (loading) {
        return <LoadingSpinner fullScreen text="Loading..." />;
    }

    if (user) {
        const role = userProfile?.role;
        console.log(`[PublicRoute] Authenticated user found (role: ${role || 'unknown'}), redirecting...`);

        if (role === USER_ROLES.SUPER_ADMIN || role === USER_ROLES.DMV_ADMIN) {
            console.log('[PublicRoute] Redirecting admin to /admin');
            return <Navigate to="/admin" replace />;
        } else if (role === USER_ROLES.INSTRUCTOR) {
            console.log('[PublicRoute] Redirecting instructor to /instructor');
            return <Navigate to="/instructor" replace />;
        } else {
            console.log('[PublicRoute] Redirecting student to', redirectTo);
            return <Navigate to={redirectTo} replace />;
        }
    }

    return children;
};


export default PublicRoute;
